import { setSuperUserAbilities } from '@/services/ability.service'

export default {
  abilities(state) {
    if (state.currentUser.abilities === '*') {
      return setSuperUserAbilities()
    }

    return state.currentUser.abilities
  },
  definedAbilities(state) {
    return state.definedAbilites
  },
}
